import {
  ACTION_SAVE_ACTION_REQUEST,
  ACTION_CLEAR_MAGIC_LINK
} from "UserAuthorized/actionTypes";

export const actionSaveAction = actionRequest => {
  return { type: ACTION_SAVE_ACTION_REQUEST, payload: actionRequest };
};
export const actionClearMagicLink = () => {
  return { type: ACTION_CLEAR_MAGIC_LINK, payload: {} };
};
